<template>
  <div class="main-content">
    <top-container
      :image="headerImage"
      :callToActionText="callToActionText"
      :callToActionBtnText="callToActionBtnText"
      :callToActionUrl="callToActionUrl"
      :pageTitle="pageTitle"
      :isHomepage="homepage" />

    <div class="content-page">
      <span v-if="graduate">
        <template v-for="(grad, index) in getAllGraduatesByLanguage">
          <span v-bind:key="grad.id">
            <col-2-graduate-left v-if="!(index % 2)" :content="grad.content.html" :position="grad.quotePositionAndName" :image="grad.content.image" :slug="grad.slug" />
            <col-2-graduate-right v-if="(index % 2)" :content="grad.content.html" :position="grad.quotePositionAndName" :image="grad.content.image" :slug="grad.slug" />
            <div v-if="index != getAllGraduatesByLanguage.length - 1">
              <hr style="margin: 20px; padding-top: 20px; padding-bottom: 20px;" />
            </div>
          </span>
        </template>
      </span>

      <template v-if="!graduate">
        <simple-page v-if="simplePage" :title="pageContent.content.title" :content="pageContent.content.simplePage.html" />
        <col-2 v-if="pageCol2" :content="pageContent.content.col2" />
        <col-3 v-if="col3" :content="pageContent.content.col3" :title="pageContent.content.homepage_title" />
        <col-2-with-infobox v-if="col2WithInfoBox" :content="pageContent.content.col2WithInfoBox.html" :infoboxes="pageContent.content.col2WithInfoBox.infoboxes" :movie="pageContent.content.col2WithInfoBox.movie"/>
        <col-2-with-movie v-if="col2WithMovie" :status="cookieStatusBool" :content="pageContent.content.col2WithMovie.html" :movieUrl="pageContent.content.col2WithMovie.movie" />
        <col-3-with-forms v-if="col3WithForms" :showMap="showMap" :content="pageContent.content.col2WithForm.html" :form="pageContent.content.col2WithForm.form.fields" :settings="pageContent.content.col2WithForm.form.settings" :slug="slug" :langIso="getCurrentLanguage.isoCode" :mapsData="pageContent.content.col2WithForm" />
        <page-with-scrollspy v-if="pageWithScrollSpy" :content="pageContent.content.col1ScrollSpy.html" :titles="pageContent.content.col1ScrollSpy.scrollSpy" />
        <col-1 v-if="col1" :content="pageContent.content.col1" />
      </template>
    </div>

    <vue-cookie-accept-decline
      :ref="'consent'"
      :elementId="'consent'"
      :debug="false"
      :position="'bottom-left'"
      :type="'floating'"
      :disableDecline="false"
      :transitionName="'slideFromTop'"
      :showPostponeButton="false"
      @status="cookieStatus"
      @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline">

      <!-- Optional -->
      <div slot="postponeContent">
          &times;
      </div>

      <!-- Optional -->
      <div slot="message" v-html="cookieText">
      </div>

      <!-- Optional -->
      <div slot="declineContent">
        {{ cookieDisapprove }}
      </div>

      <!-- Optional -->
      <div slot="acceptContent">
          {{ cookieApprove }}
      </div>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Page',
  watch: {
    getPage (oldPage, newPage) {
      this.setupPage()
    },
    getWebsite (oldWebsite, newWebsite) {
      this.setupPage()
    }
  },
  mounted () {
    this.setupPage()
  },
  data () {
    return {
      loading: null,
      slug: null,
      langId: null,
      pageInfo: null,
      headerImage: null,
      siteName: '',
      logo: null,
      pageTitle: '',
      callToActionText: '',
      callToActionUrl: '',
      callToActionBtnText: '',
      metaDescription: '',
      col2WithInfoBox: false,
      col2WithMovie: false,
      simplePage: false,
      col1: false,
      infoboxes: [],
      altLangUrl: [],
      col3: false,
      col3WithForms: false,
      pageCol2: false,
      pageWithScrollSpy: false,
      pageContent: null,
      cookieStatusBool: false,
      showMap: false,
      homepage: false,
      currentPath: this.$route.path,
      cookieText: '',
      cookieApprove: '',
      cookieDisapprove: '',
      menuInfo: [],
      languageMenu: [],
      isoCode: 'nl',
      graduate: (this.$route.path.indexOf('/reviews') !== -1),
      retryCount: 0,
      cookieAcceptDecline: localStorage.getItem('vue-cookie-accept-decline-consent')
    }
  },
  metaInfo () {
    return {
      title: this.cleanPageTitle(),
      titleTemplate: '%s | ' + this.siteName,
      meta: [
        { vmid: 'description', name: 'description', content: this.metaDescription },
        {
          property: 'og:title',
          content: this.cleanPageTitle(),
          vmid: 'og:title'
        },
        {
          property: 'og:image',
          content: 'https://ws.aisaviationgroup.com/fa/img/home-fa.jpg',
          vmid: 'og:image'
        },
        {
          property: 'og:description',
          content: this.metaDescription,
          vmid: 'og:description'
        },
        {
          property: 'twitter:title',
          content: this.cleanPageTitle(),
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:image',
          content: 'https://ws.aisaviationgroup.com/fa/img/home-fa.jpg',
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.metaDescription,
          vmid: 'twitter:description'
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
          vmid: 'twitter:card'
        }
      ],
      link: this.getAlternativeLinks,
      htmlAttrs: {
        lang: this.isoCode
      }
    }
  },
  computed: {
    ...mapGetters('graduates', [
      'getAll'
    ]),
    ...mapGetters('website', [
      'getWebsite',
      'getCurrentLanguage',
      'getFooterMenuInfo',
      'getMenuInfo',
      'getAlternativeLinks',
      'getLanguageMenu',
      'getLogo',
      'getCookieInfo'
    ]),
    ...mapGetters('page', [
      'getPage',
      'getPageLoading'
    ]),
    getAllGraduatesByLanguage () {
      return this.getAll(this.getCurrentLanguage.isoCode)
    }
  },
  methods: {
    cleanPageTitle () {
      let title = this.pageTitle
      title = title.replace(/&Uuml;/g, 'U')

      return title
    },
    cookieClickedAccept () {
      this.cookieStatusBool = true
    },
    cookieClickedDecline () {
      this.cookieStatusBool = false
    },
    cookieStatus (status) {
      this.cookieStatusBool = (status === 'accept')
    },
    setupPage () {
      if (this.currentPath.length > 1) {
        if (this.currentPath.length >= 4 && this.currentPath.substring(3, 4) !== '/') {
          window.location.href = '/'
        } else {
          if ((this.currentPath.substring(1, 3) !== 'nl') &&
              (this.currentPath.substring(1, 3) !== 'en') &&
              (this.currentPath.substring(1, 3) !== 'de')) {
            if (this.currentPath.substring(3, 11) !== 'reports') {
              window.location.href = '/'
            }
          }
        }
      }

      if (this.getWebsite !== null) {
        this.siteName = this.getWebsite.siteName
        this.logo = this.getLogo
        this.menuInfo = this.getMenuInfo
        this.languageMenu = this.getLanguageMenu(this.currentPath)
      }

      const cookie = this.getCookieInfo
      this.cookieText = cookie.cookieText
      this.cookieApprove = cookie.cookieApproveText
      this.cookieDisapprove = cookie.cookieDisapproveText

      this.pageInfo = this.getPage

      if (this.pageInfo === null) {
        this.retryCount += 1

        return
      }

      if (typeof this.pageInfo.content === 'undefined') {
        if (!this.getPageLoading) {
          this.retryCount += 1

          if (this.retryCount >= 2) {
            window.location.href = '/'
          }

          return
        } else {
          return
        }
      }

      this.retryCount = 0
      this.col2WithInfoBox = false
      this.col2WithMovie = false
      this.col3 = false
      this.col3WithForms = false
      this.pageCol2 = false
      this.pageWithScrollSpy = false
      this.simplePage = false
      this.callToActionText = ''
      this.callToActionUrl = ''
      this.callToActionBtnText = ''
      this.infoboxes = []
      this.col1 = false

      this.loading = false

      if (typeof this.getCurrentLanguage === 'undefined') {
        return
      }

      this.isoCode = this.getCurrentLanguage.isoCode
      this.pageContent = this.pageInfo.content[this.getCurrentLanguage.isoCode]
      this.headerImage = this.pageContent.content.headerImage
      this.pageTitle = this.pageContent.title
      this.metaDescription = this.pageContent.content.meta_description
      this.graduate = (this.$route.path.indexOf('/reviews') !== -1)
      this.homepage = this.pageContent.homepage
      this.siteName = this.getCurrentLanguage.siteName

      if (typeof this.pageContent.content.simplePage !== 'undefined') {
        this.simplePage = true
      }

      if (typeof this.pageContent.content.call_to_action_text !== 'undefined') {
        this.callToActionText = this.pageContent.content.call_to_action_text
      }

      if (typeof this.pageContent.content.call_to_action_url !== 'undefined') {
        this.callToActionUrl = this.pageContent.content.call_to_action_url
      }

      if (typeof this.pageContent.content.call_to_action_text_button !== 'undefined') {
        this.callToActionBtnText = this.pageContent.content.call_to_action_text_button
      }

      if (typeof this.pageContent.content.html !== 'undefined') {
        this.pageCol2 = true
      }

      if (typeof this.pageContent.content.col2 !== 'undefined') {
        this.pageCol2 = true
      }

      if (typeof this.pageContent.content.col1ScrollSpy !== 'undefined') {
        this.pageWithScrollSpy = true
      }

      if (typeof this.pageContent.content.col3 !== 'undefined') {
        this.col3 = true
      }

      if (typeof this.pageContent.content.homepage_title !== 'undefined') {
        this.pageTitle = this.pageContent.content.homepage_title
      }

      if (typeof this.pageContent.slug !== 'undefined') {
        this.slug = this.pageContent.slug
      }

      if (typeof this.pageContent.content.col2WithInfoBox !== 'undefined') {
        this.col2WithInfoBox = true
        this.infoboxes = this.pageContent.content.col2WithInfoBox.infoboxes
      }

      if (typeof this.pageContent.content.col2WithMovie !== 'undefined') {
        this.col2WithMovie = false
      }

      if (typeof this.pageContent.content.col2WithForm !== 'undefined') {
        this.col3WithForms = true
        this.showMap = this.pageContent.content.col2WithForm.gmaps.hasGmaps
      }

      if (typeof this.pageContent.content.col1 !== 'undefined') {
        this.col1 = true
      }

      if (this.$route.hash.length === 0) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style scoped>
.content-page p {
  margin-left: 15px;
  margin-right: 15px;
  padding-top: 0px;
  margin-top: 0px;
}
</style>
